import { ICONS, type IconName, type IconOptions } from './icons.js';

/**
 * Preact wrapper around the shared icon set.
 *
 * `dangerouslySetInnerHTML` is safe and deliberate here: the markup comes from a frozen record of
 * literals in this repository, never from user input or the network. The alternative — hand-porting
 * every path into JSX — would fork the geometry between the Preact pages and the plain-DOM ones
 * (`/join`, `/debug`) and guarantee they drift apart.
 */
export function Icon({ name, size = 22, className }: { name: IconName } & IconOptions) {
  return (
    <svg
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
